<a *ngIf="params.data && !params.data.editable" class="cursorptr" (click)="edit($event)">Edit</a>

<a *ngIf="params.data && params.data.editable" class="cursorptr" (click)="update($event)">Update</a>

<a *ngIf="params.data && params.data.editable" class="cursorptr" (click)="cancel($event)"
style="margin-left:20px;">Cancel</a>
